import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
} from "@angular/core";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

export type BadgeStatus =
  | "plain"
  | "info"
  | "success"
  | "warning"
  | "danger"
  | "swap"
  | "swapFree"
  | "neutral";

@Component({
  selector: "app-status-badge",
  templateUrl: "./status-badge.component.html",
  styleUrl: "./status-badge.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconComponent],
})
export class StatusBadgeComponent {
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly status: InputSignal<BadgeStatus> = input.required<BadgeStatus>();
  public readonly size: InputSignal<"medium" | "large"> = input<"medium" | "large">("large");
  public readonly rounded: InputSignal<boolean> = input<boolean>(false);
  public readonly iconPath: InputSignal<string | undefined> = input<string | undefined>();
  public readonly iconType: InputSignal<string | undefined> = input<string | undefined>();

  public readonly resolvedIconPath: Signal<string | undefined> = computed(
    (): string | undefined => {
      const iconPath: string | undefined = this.iconPath();
      if (iconPath) {
        return iconPath;
      }
      const iconType: string | undefined = this.iconType();
      return iconType ? `assets/images/badge-icon-${iconType}.svg` : undefined;
    },
  );
}
